const htmlContent = `
<div id="markdown">
<h1 id="das-terraform-statefile-gcp">Das Terraform-Statefile: GCP</h1>
<p>Dies ist Teil 2 von
<a href="/terraform-statefile">Das Terraform-Statefile in Public Clouds</a> und behandelt GCP.  </p>
<h2 id="schnellstart">Schnellstart</h2>
<ol>
<li>Klonen Sie <a href="https://github.com/ludwigprager/gcp-terraform-base">dieses Repo</a>.<pre><code> git clone https://github.com/ludwigprager/gcp-terraform-base
</code></pre>
</li>
<li>Erstellen Sie ein neues Projekt in der <a href="https://console.cloud.google.com/projectcreate">GCP-Konsole</a>
und weisen Sie die Projekt-ID der Variable
<a href="https://github.com/ludwigprager/gcp-terraform-base/blob/main/set-env.sh#L6"><code>CLOUDSDK_CORE_PROJECT</code></a>
in <a href="https://github.com/ludwigprager/gcp-terraform-base/blob/main/set-env.sh">dieser Datei</a> zu.</li>
<li>Authentifizieren Sie sich mit <code>gcloud auth login</code> und rufen Sie auf<pre><code>./gcp-terraform-base/10-deploy.sh
</code></pre>
</li>
</ol>
<h2 id="zusammenfassung">Zusammenfassung</h2>
<p>In diesem Projekt führen Sie ein GCP-Deployment mit Terraform durch,
das beliebig oft von verschiedenen Installationen aus oder
in einer CI/CD-Pipeline wiederholt werden kann und dabei immer genau die in den .tf-Dateien definierten Ressourcen erzeugt.<br>Es besteht aus
diesen zwei idempotenten Schritten:</p>
<ol>
<li>Erstellung des Speichers für das Terraform-Statefile.</li>
<li>Anwendung Ihres IaC-Codes.</li>
</ol>
<h2 id="schritt-1-20-tf-backend10-createsh">Schritt 1: 20-tf-backend/10-create.sh</h2>
<p>Erstellt den Container für das Statefile, falls er noch nicht existiert.<br>Das vollständige Skript finden Sie <a href="https://github.com/ludwigprager/gcp-terraform-base/blob/main/20-tf-backend/10-create.sh">hier</a>.</p>
<pre><code>source ../set-env.sh

function bucket-exists() {
  local bucket_name=\$1

  result=\$(gsutil  ls | grep -Fx gs://\${bucket_name}/)
  if [[ &quot;\$result&quot; == &quot;gs://\${bucket_name}/&quot; ]]; then
    return 0 
  else
    return 1
  fi
}

if bucket-exists &quot;\${BUCKET_NAME}&quot;  ; then 
  echo bucket \${BUCKET_NAME} already exists
else
  echo creating bucket \${BUCKET_NAME}
  gsutil mb gs://\${BUCKET_NAME}
fi
</code></pre>
<h2 id="schritt-2-30-main10-applysh">Schritt 2: 30-main/10-apply.sh:</h2>
<p>Zuletzt wird Terraform gestartet, nachdem alle Vorbereitungen abgeschlossen sind.
<code>terraform init</code> ändert bei erneutem Aufruf nichts,
aber <code>terraform apply</code> ändert alle Ressourcen gemäß den .tf-Dateien.<br>Das vollständige Skript finden Sie <a href="https://github.com/ludwigprager/gcp-terraform-base/blob/main/30-main/10-apply.sh">hier</a>.</p>
<pre><code>source ../set-env.sh
source ./set-env.sh

terraform init \
  -input=false \
  -backend-config=&quot;bucket=\${BUCKET_NAME}&quot;

terraform apply -auto-approve
</code></pre>
<h2 id="die-tf-dateien">Die .tf-Dateien</h2>
<p>Diese Dateien enthalten die Definition der Ressourcen, die Terraform erzeugen soll.  </p>
<p>30-main/backend.tf:</p>
<pre><code>terraform {
  backend &quot;gcs&quot; {
    # unique name to identify the file within the bucket
    prefix  = &quot;my-tf-prefix&quot;
  }
}
</code></pre>
<p>30-main/provider.tf:</p>
<pre><code>provider &quot;google&quot; {
  project     = var.project_id
  region      = var.region
}
</code></pre>
<p>30-main/network.tf:</p>
<pre><code>module &quot;vpc&quot; {
  source  = &quot;terraform-google-modules/network/google&quot;
  version = &quot;3.5.0&quot;

  network_name = var.network_name
  project_id   = var.project_id

  subnets = [
    {
      subnet_name           = var.subnetwork_name
      subnet_ip             = var.cidr
      subnet_region         = var.region
      subnet_private_access = true
      description           = &quot;This subnet is managed by Terraform&quot;
    }
  ]

  secondary_ranges = {
    (var.subnetwork_name) = [
      {
                range_name    = &quot;my-pods-tf&quot;
                ip_cidr_range = &quot;10.11.0.0/16&quot;
      },
      {
                range_name    = &quot;my-services-tf&quot;
                ip_cidr_range = &quot;10.12.0.0/16&quot;
      },
    ]
  }
}
</code></pre>
<p>30-main/network-variables.tf:</p>
<pre><code>variable &quot;network_name&quot; {
  type    = string
}

variable &quot;subnetwork_name&quot; {
  type    = string
}

variable &quot;cidr&quot; {
  default     = &quot;10.16.0.0/16&quot;
}
</code></pre>

</div>
`;
export default htmlContent
